export const cacheFirstFetchPolicyObj = { fetchPolicy: 'cache-first' } as const
